<template>
  <div>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <el-button type='primary' icon='wms wms-purchaseinstock' class='navbarbtn' v-if='showSubICMOInStockPower'
        @click='showSubInStockDialogMD'>
        委外入库
      </el-button>

      <el-button type='danger' icon='wms wms-purchaseinstock' class='navbarbtn' v-if='showSubICMOOutStockPower'
        @click='showSubOutStockDialogMD'>
        委外退货
      </el-button>

      <el-button type='warning' icon='sys sys-clear' class='navbarbtn' v-if='showFINotPower'
        @click='fiNotSet'>
        入库先进先出忽略
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.itemNumber' style='width: 125px;' placeholder='物料代码'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.itemName' style='width: 125px;' placeholder='物料名称'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.sourceBillNo' style='width: 125px;' placeholder='源单单号'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :reduceHeight='200' :seqFixed='true'
      :expandRowKeys='mainTable.expandRowKeys'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='true' operationColumnWidth='130px'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <div v-if='scope.data.row.FROB === "1"'>
          <el-tooltip effect='dark' content='重新上传' placement='top-start' v-if='showReUploadSubICMOInStockPower'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='uploadSubICStockBill(scope)'><i class='sys sys-uploaddocument'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='删除' placement='top-start' v-if='showDeletedSubICMOInStockPower'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='deletedSubICStockBill(scope)'><i class='sys sys-delete'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='单据明细' placement='top-start'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='showICStockBillEntryDialogMD(scope)'><i class='sys sys-record'></i>
            </el-button>
          </el-tooltip>
        </div>
        <div v-if='scope.data.row.FROB === "-1"'>
          <el-tooltip effect='dark' content='重新上传' placement='top-start' v-if='showReUploadSubICMOOutStockPower'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='outUploadSubICStockBill(scope)'><i class='sys sys-uploaddocument'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='删除' placement='top-start' v-if='showDeletedSubICMOOutStockPower'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='outDeletedSubICStockBill(scope)'><i class='sys sys-delete'></i>
            </el-button>
          </el-tooltip>
          <el-tooltip effect='dark' content='单据明细' placement='top-start'>
            <el-button type='primary' circle style='padding: 4px;'
              @click='showICStockBillEntryDialogMD(scope)'><i class='sys sys-record'></i>
            </el-button>
          </el-tooltip>
        </div>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>料号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 350px; text-align: left;'><span style='color: #42426F;'>名称</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 150px; text-align: left;'><span style='color: #42426F;'>仓库</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 120px; text-align: left;'><span style='color: #42426F;'>仓位代码</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>批号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 120px; text-align: left;'><span style='color: #42426F;'>生成/采购日期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: left;'><span style='color: #42426F;'>保质期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>源单单号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>源单行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>规格</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='wibe in scope.data.row.detailDt1'
            :key='wibe.EntryID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{wibe.EntryID}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: blue;'>{{wibe.ItemNumber}} </span></div>
            <div class='expand-row' style='min-width: 350px; text-align: left;'><span style='color: blue;'>{{wibe.ItemName}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{wibe.Qty}}{{wibe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 150px; text-align: left;'><span style='color: blue;'>{{wibe.DCStockName}} </span></div>
            <div class='expand-row' style='min-width: 120px; text-align: left;'><span style='color: blue;'>{{wibe.DCSPNumber}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: blue;'>{{wibe.BatchNo}} </span></div>
            <div class='expand-row' style='min-width: 120px; text-align: left;'>
              <span style='color: blue;'>
                {{!wibe.KFDate ? '' : dateTimeUtil.formartDateTime(new Date(wibe.KFDate), 'yyyy-MM-dd')}}
              </span>
            </div>
            <div class='expand-row' style='min-width: 80px; text-align: left;'><span style='color: blue;'>{{wibe.KFPeriod}} </span></div>
            <div class='expand-row' style='min-width: 160px; text-align: left;'><span style='color: blue;'>{{wibe.MESSourceBillNo}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: blue;'>{{wibe.MESSourceEntryID}} </span></div>
            <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: blue;'>{{wibe.ItemModel}} </span></div>
          </div>
        </div>
      </template>
    </Table>

    <el-dialog title='委外入库' :visible.sync='showSubInStockDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单类型
        </div>
        <el-select v-model='sourceTranType' placeholder='请选择'
          class='inputField-input' :disabled='sourceInterID.length > 0'
          @change='sourceTranTypeChange'
          style='width: 200px;' size='mini'>
          <el-option v-for='sourceTranType in mainTable.sourceTranTypes'
            :key='sourceTranType.code' :label='sourceTranType.name' :value='sourceTranType.code'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单单号
        </div>
        <TableSelect v-model='sourceInterID' v-if='showSubSelect' key='PM_SubContract'
          class='inputField-input' ref='subContractSelectTable'
          :displayValue='""' :disabled='scanQRCodes.length > 0'
          returnCode='InterID' displayCode='BillNo'
          customFilterStr=" AND Status IN ('1','2')"
          style='width: 200px;' tableCode='PM_SubContract'></TableSelect>
        <TableSelect v-model='sourceInterID' v-else key='WMS_SubPOInstock'
          class='inputField-input' ref='subPOInstockSelectTable'
          :displayValue='""' :disabled='scanQRCodes.length > 0'
          returnCode='BillNo' displayCode='BillNo'
          style='width: 200px;' tableCode='WMS_SubPOInstock'></TableSelect>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          扫描条码
        </div>
        <el-input v-model='scanQRCode' size='mini' class='inputField-input'
          @keyup.enter.native='scanQRCodeEnterMD' style='width: 200px;'>
        </el-input>
      </div>
      <div style='margin-top: 40px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          收料仓库
        </div>
        <el-select v-model='icstockBillInfo.DCStockID' placeholder='请选择'
          class='inputField-input' @change='dcstockChange'
          style='width: 200px;' size='mini'>
          <el-option v-for='stock in stocks'
            :key='stock.StockID' :label='stock.Name' :value='stock.StockID'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          收料仓位
        </div>
        <TableSelect v-model='icstockBillInfo.DCSPID' ref='icstockBillInfoDCSPIDTableSelect'
          class='inputField-input'
          :displayValue='""' :customFilterStr="' AND SPGroupID=\'' + dcstockTeam + '\''"
          returnCode='SPID' displayCode='Name'
          style='width: 200px;' tableCode='BD_StockPlace'></TableSelect>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          验收人
        </div>
        <TableSelect v-model='icstockBillInfo.FManagerID'
          class='inputField-input'
          :displayValue='""' customFilterStr=" AND Deleted='0'"
          returnCode='EmployeeID' displayCode='Number' displayName='Name'
          style='width: 200px;' tableCode='BD_Employee'></TableSelect>
      </div>
      <div style='margin-top: 80px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          摘  要
        </div>
        <el-input v-model='icstockBillInfo.Explanation' size='mini' style='width: 480px;'
          class='inputField-input'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          保管人
        </div>
        <TableSelect v-model='icstockBillInfo.SManagerID'
          class='inputField-input'
          :displayValue='""' customFilterStr=" AND Deleted='0'"
          returnCode='EmployeeID' displayCode='Number' displayName='Name'
          style='width: 200px;' tableCode='BD_Employee'></TableSelect>
      </div>
      <el-table :data='scanQRCodes' border :height='getScanQRCodesTableHeight()'
        ref='scanQRCodesTable' style='margin-top: 120px;'
        :cell-style='mainTableCellStyle' row-key='GUID'
        :header-cell-style='mainTableHeaderCellStyle' size='medium'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='QRCode' label='标签号' width='200'>
        </el-table-column>
        <el-table-column prop='BI_Number' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='BI_Name' label='物料名称' width='350'>
        </el-table-column>
        <el-table-column prop='BI_Model' label='规格' width='200'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='60'>
        </el-table-column>
        <el-table-column prop='BU_Name' label='单位' width='60'>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='100'>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
        </el-table-column>
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
        <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
        </el-table-column>
        <el-table-column prop='Status' label='状态' width='60'>
          <template #default='scope'>
            {{showQRCodesTransformSpecialString('Status', scope.row.Status)}}
          </template>
        </el-table-column>
        <el-table-column label='操作' width='60' fixed='right'>
          <template #default='scope'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='deleteScanQRCode(scope.$index)'><i class='sys sys-delete'></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='subInStock()' size='mini'>入库</el-button>
        <el-button @click='showSubInStockDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title='委外退货' :visible.sync='showSubOutStockDialog' fullscreen>
      <div style='margin-top: -30px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单类型
        </div>
        <el-select v-model='outSourceTranType' placeholder='请选择'
          class='inputField-input' :disabled='true'
          style='width: 200px;' size='mini'>
          <el-option v-for='sourceTranType in mainTable.sourceTranTypes'
            :key='sourceTranType.code' :label='sourceTranType.name' :value='sourceTranType.code'>
          </el-option>
        </el-select>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          源单单号
        </div>
        <TableSelect v-model='outSourceInterID' key='OutPM_SubContract'
          class='inputField-input' ref='outSubContractSelectTable'
          :displayValue='""' :disabled='scanQRCodes.length > 0'
          returnCode='InterID' displayCode='BillNo'
          customFilterStr=" AND Status IN ('1','2')"
          style='width: 200px;' tableCode='PM_SubContract'></TableSelect>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          扫描条码
        </div>
        <el-input v-model='scanQRCode' size='mini' class='inputField-input'
          @keyup.enter.native='outScanQRCodeEnterMD' style='width: 200px;'>
        </el-input>
      </div>
      <div style='margin-top: 40px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          验收人
        </div>
        <TableSelect v-model='outICStockBillInfo.FManagerID'
          class='inputField-input'
          :displayValue='""' customFilterStr=" AND Deleted='0'"
          returnCode='EmployeeID' displayCode='Number' displayName='Name'
          style='width: 200px;' tableCode='BD_Employee'></TableSelect>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          保管人
        </div>
        <TableSelect v-model='outICStockBillInfo.SManagerID'
          class='inputField-input'
          :displayValue='""' customFilterStr=" AND Deleted='0'"
          returnCode='EmployeeID' displayCode='Number' displayName='Name'
          style='width: 200px;' tableCode='BD_Employee'></TableSelect>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          备  注
        </div>
        <el-input v-model='outICStockBillInfo.Remark' size='mini' style='width: 200px;'
          class='inputField-input'>
        </el-input>
      </div>
      <div style='margin-top: 80px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          摘  要
        </div>
        <el-input v-model='outICStockBillInfo.Explanation' size='mini' style='width: 760px;'
          class='inputField-input'>
        </el-input>
      </div>
      <el-table :data='scanQRCodes' border :height='getScanQRCodesTableHeight()'
        ref='scanQRCodesTable' style='margin-top: 120px;'
        :cell-style='mainTableCellStyle' row-key='GUID'
        :header-cell-style='mainTableHeaderCellStyle' size='medium'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='QRCode' label='标签号' width='200'>
        </el-table-column>
        <el-table-column prop='BI_Number' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='BI_Name' label='物料名称' width='350'>
        </el-table-column>
        <el-table-column prop='BI_Model' label='规格' width='200'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='60'>
        </el-table-column>
        <el-table-column prop='BU_Name' label='单位' width='60'>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='100'>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
        </el-table-column>
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
        <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
        </el-table-column>
        <el-table-column prop='InStockBillNo' label='入库单号' width='200'>
        </el-table-column>
        <el-table-column prop='Status' label='状态' width='60'>
          <template #default='scope'>
            {{showQRCodesTransformSpecialString('Status', scope.row.Status)}}
          </template>
        </el-table-column>
        <el-table-column label='操作' width='60' fixed='right'>
          <template #default='scope'>
            <el-button type='danger' circle style='padding: 4px;'
              @click='outDeleteScanQRCode(scope.$index)'><i class='sys sys-delete'></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='subOutStock()' size='mini'>退货</el-button>
        <el-button @click='showSubOutStockDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag title='委外入库单明细' :visible.sync='showICStockBillEntryDialog' width='920px'
      top='10px' lock-scroll>
      <el-table :data='icStockBillEntry' border height='300px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;' default-expand-all>
        <el-table-column type='expand' width='50'>
          <template #default='scope'>
            <div class='expand'>
              <div class='expand-inner'>
                <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>内箱标签号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>外箱标签号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>供应商批号</span></div>
              </div>
            </div>
            <div class='expand'>
              <div v-for='(qrCode, qrCodeIndex) in scope.row.detailDt1'
                :key='qrCode.QRCode' class='expand-inner'>
                <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: #42426F;'></span>{{qrCodeIndex + 1}} </div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.QRCode}} </div>
                <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'></span>{{qrCode.Qty}}{{qrCode.BU_Name}} </div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.OuterQRCode}} </div>
                <div class='expand-row' style='min-width: 160px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.SupplyBatchNo}} </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop='EntryID' label='行号' width='60'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='300'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='规格型号' width='250'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='80'>
        </el-table-column>
        <el-table-column prop='UnitName' label='单位' width='80'>
        </el-table-column>
        <el-table-column prop='DCStockName' label='仓库' width='160'>
        </el-table-column>
        <el-table-column prop='DCSPNumber' label='仓位代码' width='120'>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='100'>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
        </el-table-column>
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import TableSelect from '@/components/custom/TableSelect.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import code from '@/components/sys/Code'
import power from '@/components/sys/Power'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'

export default {
  name: 'SubInStock',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel,
    TableSelect: TableSelect
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'WMS_ICStockBill_SubI',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        detail1FilterStr: '',
        itemNumber: '',
        itemName: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: [],

        sourceTranTypes: []
      },

      dateTimeUtil: dateTimeUtil,

      showSubInStockDialog: false,
      sourceTranType: '1007105',
      sourceInterID: '',
      scanQRCode: '',
      scanQRCodes: [],
      qrcodeStatuss: [],
      stocks: [],
      dcstockTeam: '',
      icstockBillInfo: {
        DCStockID: '',
        DCSPID: '',
        FManagerID: '',
        SManagerID: '',
        Explanation: ''
      },
      showSubSelect: true,

      showSubOutStockDialog: false,
      outSourceTranType: '1007105',
      outSourceInterID: '',
      outICStockBillInfo: {
        FManagerID: '',
        SManagerID: '',
        Explanation: '',
        Remark: ''
      },

      showICStockBillEntryDialog: false,
      icStockBillEntry: [],
      icStockBill: {},

      showSubICMOInStockPower: false,
      showReUploadSubICMOInStockPower: false,
      showDeletedSubICMOInStockPower: false,
      showSubICMOOutStockPower: false,
      showReUploadSubICMOOutStockPower: false,
      showDeletedSubICMOOutStockPower: false,
      showFINotPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)
    const codes = that.codes
    that.mainTable.sourceTranTypes = code.getCode(codes, 'WMS_TranType', ['1007105', '72'])
    that.qrcodeStatuss = code.getCode(codes, 'WMS_QRCode_Status')

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')
    const stockObjPromise = table.getTableContent('BD_Stock', 10000, 1, '', " AND Deleted='0'")

    await tableContentPromise
    await tableFilterInfoPromise
    const stockObj = await stockObjPromise
    that.stocks = stockObj.tableContent
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.mainTable.detail1FilterStr = ''
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.itemNumber) {
        const itemNumbers = that.mainTable.itemNumber.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNumbers.length; i++) {
          detail1FilterStr += " OR ItemNumber LIKE'%" + itemNumbers[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.itemName) {
        const itemNames = that.mainTable.itemName.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNames.length; i++) {
          detail1FilterStr += " OR ItemName LIKE'%" + itemNames[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.sourceBillNo) {
        const sourceBillNos = that.mainTable.sourceBillNo.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < sourceBillNos.length; i++) {
          detail1FilterStr += " OR SourceBillNo LIKE'%" + sourceBillNos[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.FROB === '-1') {
        if (data.row.HaveToErp === '0') {
          return { 'background-color': '#FF6347', color: 'red' }
        } else if (data.row.Closed === '1' || data.row.Status === '3') {
          return { 'background-color': '#CCCCCC', color: 'red' }
        } else {
          return { color: 'red' }
        }
      } else {
        if (data.row.HaveToErp === '0') {
          return { 'background-color': '#FF6347' }
        } else if (data.row.Closed === '1' || data.row.Status === '3') {
          return { 'background-color': '#CCCCCC' }
        } else {
          return {}
        }
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 表格单元格样式
    mainTableCellStyle: function () {
      return { padding: '0px' }
    },

    // 表格表头单元格样式
    mainTableHeaderCellStyle: function ({ column, columnIndex, row, rowIndex }) {
      return { padding: '5px', 'background-color': '#f5f7fa' }
    },

    // 委外入库单弹出框显示方法
    showSubInStockDialogMD: function () {
      const that = this
      that.scanQRCodes = []
      if (that.$refs.subContractSelectTable) {
        that.$refs.subContractSelectTable.clearSelected()
      }
      if (that.$refs.subPOInstockSelectTable) {
        that.$refs.subPOInstockSelectTable.clearSelected()
      }
      that.showSubInStockDialog = true
    },

    // 获取委外入库扫描标签表格高度
    getScanQRCodesTableHeight: function () {
      return window.innerHeight - 250 + 'px'
    },

    // 源单类型改变事件方法
    sourceTranTypeChange: function () {
      const that = this
      that.showSubSelect = that.sourceTranType === '1007105'
    },

    // 显示条码明细表格特征字符串转换方法
    showQRCodesTransformSpecialString: function (columnCode, val) {
      const that = this
      if (columnCode === 'Status') {
        return table.specialStringDisplayTransform(val, that.qrcodeStatuss)
      }
    },

    // 发料仓库选择方法
    dcstockChange: function () {
      const that = this
      if (that.$refs.icstockBillInfoDCSPIDTableSelect) {
        that.$refs.icstockBillInfoDCSPIDTableSelect.clearSelected()
      }
      for (let i = 0; i < that.stocks.length; i++) {
        if (that.stocks[i].StockID === that.icstockBillInfo.DCStockID) {
          that.dcstockTeam = that.stocks[i].SPGroupID
          break
        }
      }
    },

    // 扫码方法
    scanQRCodeEnterMD: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      let qrCodeObj = null
      if (that.scanQRCode.indexOf('|') > 0) {
        that.scanQRCode = that.scanQRCode.substring(0, that.scanQRCode.indexOf('|'))
      }
      let addNum = 0
      qrCodeObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.GetQRCode', {
        qrCode: that.scanQRCode
      })
      if (qrCodeObj.error === '000000') {
        if (qrCodeObj.tableContent.length <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号不存在！')
          that.scanQRCode = ''
          return
        }
        if (that.sourceTranType === '1007105') {
          for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
            if (qrCodeObj.tableContent[i].Status !== '0') {
              continue
            } else if (qrCodeObj.tableContent[i].InitType !== '3') {
              loadingInstance.close()
              that.$message.error('该标签号不是通过委外订单直接或间接生成的，请扫描委外订单直接或间接生成的标签号！')
              that.scanQRCode = ''
              return
            } else if (that.sourceInterID && that.sourceInterID !== qrCodeObj.tableContent[i].SubContractInterID) {
              loadingInstance.close()
              that.$message.error('该标签号不是通过该委外订单直接或间接生成的，请扫描该委外订单直接或间接生成的标签号！')
              that.scanQRCode = ''
              return
            } else {
              let haveScanFlag = false
              for (let j = 0; j < that.scanQRCodes.length; j++) {
                if (that.scanQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
                  haveScanFlag = true
                }
              }
              if (haveScanFlag) {
                qrCodeObj.tableContent[i].haveScanFlag = true
              }
            }
          }
          for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
            if (qrCodeObj.tableContent[i].Status !== '0') {
              continue
            }
            if (qrCodeObj.tableContent[i].haveScanFlag) {
              addNum++
              continue
            }
            that.scanQRCodes.push(qrCodeObj.tableContent[i])
            addNum++
          }
          that.scanQRCode = ''
          if (addNum <= 0) {
            loadingInstance.close()
            that.$message.error('该外箱标签号中的没有可以直接入库的内箱标签！')
            return
          }
          if (!that.sourceInterID) {
            for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
              if (qrCodeObj.tableContent[i].Status !== '0') {
                continue
              }
              that.$refs.subContractSelectTable.setSelected(qrCodeObj.tableContent[i].SubContractInterID, qrCodeObj.tableContent[0].SubContractBillNo)
              break
            }
          }
        } else if (that.sourceTranType === '72') {
          for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
            if (qrCodeObj.tableContent[i].Status !== '7') {
              continue
            } else if (qrCodeObj.tableContent[i].InitType !== '3') {
              loadingInstance.close()
              that.$message.error('该标签号不是通过委外订单直接或间接生成的，请扫描委外订单直接或间接生成的标签号！')
              that.scanQRCode = ''
              return
            } else if (that.sourceInterID && that.sourceInterID !== qrCodeObj.tableContent[i].POInStockBillInterID) {
              loadingInstance.close()
              that.$message.error('该标签号不是通过该收料通知/请检单收料的，请扫描通过该收料通知/请检单收料的的标签号！')
              that.scanQRCode = ''
              return
            } else {
              let haveScanFlag = false
              for (let j = 0; j < that.scanQRCodes.length; j++) {
                if (that.scanQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
                  haveScanFlag = true
                  break
                }
              }
              if (haveScanFlag) {
                qrCodeObj.tableContent[i].haveScanFlag = true
              }
            }
          }
          for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
            if (qrCodeObj.tableContent[i].Status !== '7') {
              continue
            }
            if (qrCodeObj.tableContent[i].haveScanFlag) {
              addNum++
              continue
            }
            that.scanQRCodes.push(qrCodeObj.tableContent[i])
            addNum++
          }
          that.scanQRCode = ''
          if (addNum <= 0) {
            loadingInstance.close()
            that.$message.error('该外箱标签号中的没有可以通过该收料通知/请检单入库的内箱标签！')
            return
          }
          if (!that.sourceInterID) {
            for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
              if (qrCodeObj.tableContent[i].Status !== '7') {
                continue
              }
              that.$refs.subPOInstockSelectTable.setSelected(qrCodeObj.tableContent[i].POInStockBillInterID, qrCodeObj.tableContent[0].POInStockBillNo)
              break
            }
          }
        }
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 删除已扫描
    deleteScanQRCode: function (index) {
      const that = this
      that.scanQRCodes.splice(index, 1)
      if (that.scanQRCodes.length === 0) {
        if (that.$refs.subContractSelectTable) {
          that.$refs.subContractSelectTable.clearSelected()
        }
        if (that.$refs.subPOInstockSelectTable) {
          that.$refs.subPOInstockSelectTable.clearSelected()
        }
      }
    },

    // 委外入库
    subInStock: async function () {
      const that = this
      if (!that.sourceTranType) {
        that.$message.error('请选择源单类型！')
        return
      }
      if (!that.sourceInterID) {
        that.$message.error('请选择源单！')
        return
      }
      if (that.scanQRCodes.length <= 0) {
        that.$message.error('请扫码')
        return
      }
      if (!that.icstockBillInfo.DCStockID) {
        that.$message.error('请选择收料仓库！')
        return
      }
      if (!that.icstockBillInfo.DCSPID) {
        that.$message.error('请选择收料仓位！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.SubInStock.ScanSubContractInStock', {
        sourceTranType: that.sourceTranType,
        sourceInterID: that.sourceInterID,
        scanQRCodes: that.scanQRCodes,
        icstockBillInfo: that.icstockBillInfo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showSubInStockDialog = false
        if (rtnObj.msg) {
          that.$message.warning('入库成功，但是有异常信息！【' + rtnObj.msg + '】')
        } else {
          that.$message.success('入库成功！')
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 重新上传委外入库单至金蝶
    uploadSubICStockBill: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/UploadToERP.UploadICStockBill.UploadICStockBill5', {
        billNo: scope.data.row.BillNo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('重新上传成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 删除委外入库单
    deletedSubICStockBill: async function (scope) {
      const that = this
      that.$confirm('确定要删除该委外入库单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.SubInStock.DeleteScanSubContractInStock', {
          billNo: scope.data.row.BillNo
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('删除成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 委外入库单明细显示方法
    showICStockBillEntryDialogMD: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const icStockBillEntryObj = await table.getTableContent('WMS_ICStockBillEntry_SubI'
        , 10000, 1, ' EntryID ASC', " AND BillNo='" + scope.data.row.BillNo + "'")
      if (icStockBillEntryObj.error === '000000') {
        that.icStockBillEntry = icStockBillEntryObj.tableContent
        that.icStockBill = scope.data.row
        that.showICStockBillEntryDialog = true
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 委外退货单弹出框显示方法
    showSubOutStockDialogMD: function () {
      const that = this
      that.scanQRCodes = []
      if (that.$refs.outSubContractSelectTable) {
        that.$refs.outSubContractSelectTable.clearSelected()
      }
      that.showSubOutStockDialog = true
    },

    // 扫码方法
    outScanQRCodeEnterMD: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      let qrCodeObj = null
      if (that.scanQRCode.indexOf('|') > 0) {
        that.scanQRCode = that.scanQRCode.substring(0, that.scanQRCode.indexOf('|'))
      }
      let addNum = 0
      qrCodeObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.GetQRCode', {
        qrCode: that.scanQRCode
      })
      if (qrCodeObj.error === '000000') {
        if (qrCodeObj.tableContent.length <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号不存在！')
          that.scanQRCode = ''
          return
        }
        if (that.outSourceTranType === '1007105') {
          for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
            if (qrCodeObj.tableContent[i].Status !== '1') {
              continue
            } else if (qrCodeObj.tableContent[i].InitType !== '3') {
              loadingInstance.close()
              that.$message.error('该标签号不是通过委外订单直接或间接生成的，请扫描委外订单直接或间接生成的标签号！')
              that.scanQRCode = ''
              return
            } else if (that.outSourceInterID && that.outSourceInterID !== qrCodeObj.tableContent[i].SubContractInterID) {
              loadingInstance.close()
              that.$message.error('该标签号不是通过该委外订单直接或间接生成的，请扫描该委外订单直接或间接生成的标签号！')
              that.scanQRCode = ''
              return
            } else {
              let haveScanFlag = false
              for (let j = 0; j < that.scanQRCodes.length; j++) {
                if (that.scanQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
                  haveScanFlag = true
                }
              }
              if (haveScanFlag) {
                qrCodeObj.tableContent[i].haveScanFlag = true
              }
            }
          }
          for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
            if (qrCodeObj.tableContent[i].Status !== '1') {
              continue
            }
            if (qrCodeObj.tableContent[i].haveScanFlag) {
              addNum++
              continue
            }
            that.scanQRCodes.push(qrCodeObj.tableContent[i])
            addNum++
          }
          that.scanQRCode = ''
          if (addNum <= 0) {
            loadingInstance.close()
            that.$message.error('该外箱标签号中的没有可以直接退货的内箱标签！')
            return
          }
          if (!that.outSourceInterID) {
            for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
              if (qrCodeObj.tableContent[i].Status !== '1') {
                continue
              }
              that.$refs.outSubContractSelectTable.setSelected(qrCodeObj.tableContent[i].SubContractInterID, qrCodeObj.tableContent[0].SubContractBillNo)
              break
            }
          }
        }
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 删除已扫描
    outDeleteScanQRCode: function (index) {
      const that = this
      that.scanQRCodes.splice(index, 1)
      if (that.scanQRCodes.length === 0) {
        if (that.$refs.outSubContractSelectTable) {
          that.$refs.outSubContractSelectTable.clearSelected()
        }
      }
    },

    // 委外退货
    subOutStock: async function () {
      const that = this
      if (!that.outSourceTranType) {
        that.$message.error('请选择源单类型！')
        return
      }
      if (that.scanQRCodes.length <= 0) {
        that.$message.error('请扫码')
        return
      }
      if (!that.outSourceInterID) {
        that.$message.error('请选择源单！')
        return
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.SubInStock.ScanSubContractOutStock', {
        outSourceTranType: that.outSourceTranType,
        outSourceInterID: that.outSourceInterID,
        scanQRCodes: that.scanQRCodes,
        outICStockBillInfo: that.outICStockBillInfo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.showSubOutStockDialog = false
        if (rtnObj.msg) {
          that.$message.warning('退货成功，但是有异常信息！【' + rtnObj.msg + '】')
        } else {
          that.$message.success('退货成功！')
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 重新上传委外退货单至金蝶
    outUploadSubICStockBill: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/UploadToERP.UploadICStockBill.UploadICStockBill5', {
        billNo: scope.data.row.BillNo
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('重新上传成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 删除委外退货单
    outDeletedSubICStockBill: async function (scope) {
      const that = this
      that.$confirm('确定要删除该外购退货单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.SubInStock.DeleteScanSubContractOutStock', {
          billNo: scope.data.row.BillNo
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('删除成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 入库先进先出忽略
    fiNotSet: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      that.$confirm('确定要忽略该入库单的入库先进先出卡控吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.FINotSet', {
          rows: that.mainTable.selections
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('忽略成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
  float: left;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
.tableInput {
  height: 26px;
  line-height: 26px;
  border: 0px #FFFFFF;
  background-color: transparent;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
</style>
